import { IOption } from '@cian/ui-kit';
import { ERooms } from '../../types/filters';

export const roomsOptions: IOption<ERooms>[] = [
  { label: 'Студия', value: ERooms.Studio },
  { label: '1', value: ERooms.OneRoom },
  { label: '2', value: ERooms.TwoRoom },
  { label: '3', value: ERooms.ThreeRoom },
  { label: '4+', value: ERooms.FourRoom },
];
